var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.397 5.423l-7.308 7.372a2.238 2.238 0 00-.677 1.591 2.256 2.256 0 00.65 1.603 2.218 2.218 0 001.588.655 2.202 2.202 0 001.577-.683l7.117-7.373a4.499 4.499 0 001.246-3.15 4.498 4.498 0 00-1.3-3.127 4.42 4.42 0 00-3.1-1.31 4.418 4.418 0 00-3.122 1.256L2.95 9.628A6.747 6.747 0 001 14.378c0 1.782.701 3.49 1.95 4.75a6.629 6.629 0 004.708 1.967c1.766 0 3.46-.707 4.708-1.967l6.943-6.989",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default __webpack_public_path__ + "static/media/link.5c36af83.svg";
export { SvgLink as ReactComponent };